(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-carousel"] && !Shopify.designMode) return;
  try {
    class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');

      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index))));
      this.prevButton?.addEventListener('click', () => this.scrollBySlide(-1));
      this.nextButton?.addEventListener('click', () => this.scrollBySlide(1));

      this.track.addEventListener(
        'scroll',
        () => {
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(this.onScroll.bind(this));
        },
        { passive: true }
      );

      this.onScroll();
    }

    goTo(index) {
      const clamped = Math.max(0, Math.min(index, this.slides.length - 1));
      this.slides[clamped]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    step() {
      const slide = this.slides[0];
      if (!slide) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
      return slide.offsetWidth + gap;
    }

    scrollBySlide(direction) {
      this.track.scrollBy({ left: this.step() * direction, behavior: 'smooth' });
    }

    onScroll() {
      const step = this.step();
      const index = step > 0 ? Math.round(this.track.scrollLeft / step) : 0;
      const clamped = Math.max(0, Math.min(index, this.slides.length - 1));

      this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === clamped)));

      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 1;
      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      }
    }
  }

  if (!customElements.get('product-carousel')) {
    customElements.define('product-carousel', ProductCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ThemeProductGallery extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
      this.setupSwipe();
      document.addEventListener('variant:change', (event) => {
        const media = event.detail?.featured_media;
        if (media && this.querySelector(`[data-gallery-image="${media.id}"]`)) this.showImage(String(media.id));
      });
      this.thumbsTrack = this.querySelector('[data-thumbs-track]');
      this.thumbsPrev = this.querySelector('[data-thumbs-prev]');
      this.thumbsNext = this.querySelector('[data-thumbs-next]');

      this.lightbox = this.parentElement?.querySelector('.product-gallery-lightbox');
      this.lightboxImage = this.lightbox?.querySelector('[data-lightbox-image]');
      if (this.lightbox) {
        this.lightbox.addEventListener('click', this.onLightboxClick.bind(this));
        this.lightbox.addEventListener('keydown', this.onLightboxKeydown.bind(this));
      }

      if (this.thumbsTrack) {
        this.thumbsTrack.addEventListener(
          'scroll',
          () => {
            if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = requestAnimationFrame(this.updateThumbArrows.bind(this));
          },
          { passive: true }
        );
        this.updateThumbArrows();
        const activeThumb = this.querySelector('.product-gallery__thumbnail.is-active');
        if (activeThumb) this.scrollThumbIntoView(activeThumb);
      }
    }

    // Phones: the main picture follows the finger like on Amazon. Drag left or right and the next or previous
    // picture or video slides in next to it; let go past a fifth of the width (or flick) to move there,
    // otherwise it springs back. A mostly-vertical move is left to the page scroll. On a video, touches that
    // start on the control bar (the bottom 3.5rem) are ignored so scrubbing the timeline still works.
    setupSwipe() {
      const stage = this.querySelector('.product-gallery__image');
      if (!stage) return;
      const items = () => Array.from(this.querySelectorAll('.product-gallery__main-image'));
      if (items().length < 2) return;
      let drag = null;
      let pending = null; // the slide that is still animating after the finger let go

      // A new swipe while the last one is still sliding: finish the last one at once, so the two never fight.
      const settle = () => {
        if (!pending) return;
        clearTimeout(pending.timer);
        const done = pending.done;
        pending = null;
        done();
      };

      const place = (el, x, animate) => {
        el.style.transition = animate ? 'transform 0.25s ease-out' : 'none';
        el.style.transform = `translateX(${x}px)`;
        el.style.opacity = '1';
      };
      const clear = (el) => {
        el.style.transition = 'none';
        el.style.transform = '';
        el.style.opacity = '';
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            if (!el.style.transform) el.style.transition = ''; // unless a new swipe has already taken it
          })
        );
      };
      const neighbour = (d, dir) => {
        const all = items();
        const n = all[(d.index + dir + all.length) % all.length];
        if (n.tagName === 'IMG') n.loading = 'eager';
        return n;
      };

      stage.addEventListener(
        'touchstart',
        (event) => {
          drag = null;
          settle();
          if (event.touches.length !== 1 || this.lightbox?.open) return;
          // Load every picture now so the next one is ready when it slides in, even on a quick flick.
          items().forEach((el) => {
            if (el.tagName === 'IMG') el.loading = 'eager';
          });
          const touch = event.touches[0];
          const rect = stage.getBoundingClientRect();
          if (this.classList.contains('is-showing-video') && touch.clientY > rect.bottom - 56) return;
          const all = items();
          const index = all.findIndex((el) => el.classList.contains('is-active'));
          if (index < 0) return;
          drag = { x: touch.clientX, y: touch.clientY, time: Date.now(), width: rect.width, index, current: all[index], mode: null, other: null, dir: 0, dx: 0 };
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchmove',
        (event) => {
          if (!drag) return;
          const touch = event.touches[0];
          const dx = touch.clientX - drag.x;
          const dy = touch.clientY - drag.y;
          // Decide on the very first move: iPhones only let a gesture stop the page scroll if the first move is
          // stopped, so waiting a few pixels lets the page drift up and down while swiping sideways.
          // A tie or a mostly-vertical first move always goes to the page scroll, so scrolling down from the
          // picture to the price and buy button is never blocked; only a clearly sideways move drags the picture.
          if (!drag.mode) {
            const ax = Math.abs(dx), ay = Math.abs(dy);
            if (ay > 0 && ay >= ax) drag.mode = 'y';
            else if (ax >= 2 && ax > ay) drag.mode = 'x';
            else return;
          }
          if (drag.mode !== 'x') return;
          // Hold the page still while the picture is being dragged sideways.
          if (event.cancelable) event.preventDefault();
          const dir = dx < 0 ? 1 : -1;
          if (dir !== drag.dir) {
            if (drag.other) clear(drag.other);
            drag.dir = dir;
            drag.other = neighbour(drag, dir);
          }
          drag.dx = dx;
          place(drag.current, dx, false);
          place(drag.other, dx + dir * drag.width, false);
        },
        { passive: false }
      );

      const finish = () => {
        const d = drag;
        drag = null;
        if (!d || d.mode !== 'x' || !d.other) return;
        this.swipedAt = Date.now();
        const flick = Date.now() - d.time < 300 && Math.abs(d.dx) > 30;
        const go = Math.abs(d.dx) > d.width / 5 || flick;
        if (go) {
          place(d.current, -d.dir * d.width, true);
          place(d.other, 0, true);
        } else {
          place(d.current, 0, true);
          place(d.other, d.dir * d.width, true);
        }
        const done = () => {
          if (go) {
            this.showImage(d.other.dataset.galleryImage);
            this.playActiveMedia();
          }
          clear(d.current);
          clear(d.other);
        };
        pending = { done, timer: setTimeout(settle, 260) };
      };
      stage.addEventListener('touchend', finish, { passive: true });
      stage.addEventListener('touchcancel', finish, { passive: true });
    }

    onClick(event) {
      if (this.swipedAt && Date.now() - this.swipedAt < 500 && event.target.closest('.product-gallery__image')) return;
      const thumbnail = event.target.closest('.product-gallery__thumbnail');
      if (thumbnail) {
        this.showImage(thumbnail.dataset.galleryTarget);
        this.playActiveMedia();
        return;
      }
      if (event.target.closest('[data-gallery-prev]')) {
        this.showRelativeImage(-1);
        this.playActiveMedia();
        return;
      }
      if (event.target.closest('[data-gallery-next]')) {
        this.showRelativeImage(1);
        this.playActiveMedia();
        return;
      }
      if (event.target.closest('[data-thumbs-prev]')) {
        this.scrollThumbs(-1);
        return;
      }
      if (event.target.closest('[data-thumbs-next]')) {
        this.scrollThumbs(1);
        return;
      }
      if (event.target.closest('[data-gallery-zoom]')) {
        this.updateLightboxImage();
        return;
      }
      if (event.target.closest('img.product-gallery__main-image.is-active')) {
        this.updateLightboxImage();
        window.openDialog?.(this.lightbox);
      }
    }

    onLightboxClick(event) {
      if (event.target.closest('[data-lightbox-prev]')) {
        this.showRelativeImage(-1);
        return;
      }
      if (event.target.closest('[data-lightbox-next]')) {
        this.showRelativeImage(1);
      }
    }

    onLightboxKeydown(event) {
      if (event.key === 'ArrowLeft') {
        this.showRelativeImage(-1);
      } else if (event.key === 'ArrowRight') {
        this.showRelativeImage(1);
      }
    }

    updateLightboxImage() {
      if (!this.lightboxImage) return;
      const activeImage = this.querySelector('img.product-gallery__main-image.is-active');
      if (!activeImage) return;
      this.lightboxImage.src = activeImage.src.replace(/width=\d+/, 'width=1600');
      this.lightboxImage.alt = activeImage.alt;
    }

    showImage(imageId) {
      this.querySelectorAll('.product-gallery__main-image').forEach((image) => {
        const isActive = image.dataset.galleryImage === imageId;
        if (!isActive && image.classList.contains('is-active')) this.pauseMedia(image);
        image.classList.toggle('is-active', isActive);
        if (isActive) this.classList.toggle('is-showing-video', image.dataset.mediaType !== 'image');
      });
      this.querySelectorAll('.product-gallery__thumbnail').forEach((thumbnail) => {
        const isActive = thumbnail.dataset.galleryTarget === imageId;
        thumbnail.classList.toggle('is-active', isActive);
        if (isActive) this.scrollThumbIntoView(thumbnail);
      });
    }

    pauseMedia(item) {
      item.querySelectorAll('video').forEach((video) => video.pause());
      item.querySelectorAll('iframe').forEach((frame) => {
        try {
          frame.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          frame.contentWindow?.postMessage('{"method":"pause"}', '*');
        } catch (e) {}
      });
    }

    // When a shopper picks a video (thumbnail or arrow), start it right away instead of waiting for a second tap.
    // The tap counts as a user action, so browsers allow sound; if one still blocks it, play muted.
    playActiveMedia() {
      if (this.lightbox?.open) return;
      const item = this.querySelector('.product-gallery__main-image.is-active');
      if (!item || item.dataset.mediaType === 'image') return;
      const video = item.querySelector('video');
      if (video) {
        const started = video.play();
        if (started && started.catch) {
          started.catch(() => {
            video.muted = true;
            video.play().catch(() => {});
          });
        }
        return;
      }
      item.querySelectorAll('iframe').forEach((frame) => {
        try {
          frame.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          frame.contentWindow?.postMessage('{"method":"play"}', '*');
        } catch (e) {}
      });
    }

    showRelativeImage(direction) {
      const all = Array.from(this.querySelectorAll('.product-gallery__main-image'));
      // The zoom view only shows pictures, so it skips videos.
      const images = this.lightbox?.open ? all.filter((item) => item.dataset.mediaType === 'image') : all;
      if (images.length < 2) return;
      let currentIndex = images.findIndex((image) => image.classList.contains('is-active'));
      if (currentIndex < 0) currentIndex = 0;
      const nextIndex = (currentIndex + direction + images.length) % images.length;
      this.showImage(images[nextIndex].dataset.galleryImage);
      if (this.lightbox?.open) this.updateLightboxImage();
    }

    scrollThumbs(direction) {
      const thumb = this.thumbsTrack?.querySelector('.product-gallery__thumbnail');
      if (!thumb) return;
      const gap = parseFloat(getComputedStyle(this.thumbsTrack).columnGap || '0');
      this.thumbsTrack.scrollBy({ left: (thumb.offsetWidth + gap) * direction, behavior: 'smooth' });
    }

    scrollThumbIntoView(thumbnail) {
      if (!this.thumbsTrack) return;
      const trackRect = this.thumbsTrack.getBoundingClientRect();
      const thumbRect = thumbnail.getBoundingClientRect();
      let delta = 0;
      if (thumbRect.left < trackRect.left) {
        delta = thumbRect.left - trackRect.left;
      } else if (thumbRect.right > trackRect.right) {
        delta = thumbRect.right - trackRect.right;
      }
      if (delta !== 0) this.thumbsTrack.scrollBy({ left: delta, behavior: 'smooth' });
    }

    updateThumbArrows() {
      if (!this.thumbsTrack) return;
      if (this.thumbsPrev) this.thumbsPrev.disabled = this.thumbsTrack.scrollLeft <= 1;
      if (this.thumbsNext) {
        this.thumbsNext.disabled =
          this.thumbsTrack.scrollLeft + this.thumbsTrack.clientWidth >= this.thumbsTrack.scrollWidth - 1;
      }
    }
  }

  if (!customElements.get('theme-product-gallery')) {
    customElements.define('theme-product-gallery', ThemeProductGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-volume-tiers"] && !Shopify.designMode) return;
  try {
    class ThemeVolumeTiers extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange.bind(this));
      this.price = Number(this.dataset.price) || 0;
      this.compareAt = Number(this.dataset.compareAt) || this.price;
      document.addEventListener('variant:change', (event) => {
        if (!event.detail) return;
        this.price = event.detail.price;
        this.compareAt = Math.max(event.detail.compare_at_price || 0, event.detail.price);
        setTimeout(() => this.reprice(event.detail.price), 0);
      });
    }

    // Show the chosen tier in the price box at the top: total for all units, the regular price for
    // the same units crossed out, and the total saving (sale price + quantity discount).
    showInPriceBox(radio) {
      const money = window.themeStrings.formatMoney;
      const box = document.querySelector('[data-product-price]');
      if (!box || !radio) return;
      const quantity = Number(radio.dataset.quantity) || 1;
      const total = Math.round(this.price * quantity * (1 - (Number(radio.dataset.discount) || 0) / 100));
      const regular = Math.max(this.compareAt, this.price) * quantity;
      const current = box.querySelector('.price__current');
      const compareEl = box.querySelector('.price__compare-at');
      if (current) current.textContent = money(total);
      if (compareEl) { compareEl.textContent = money(regular); compareEl.hidden = !(regular > total); }
      const savings = box.querySelector('.product-page__savings');
      if (savings && savings.dataset.template) {
        savings.hidden = !(regular > total);
        if (regular > total) savings.innerHTML = savings.dataset.template.replace('[amount]', money(regular - total));
      }
      const badge = document.querySelector('[data-sale-badge]');
      if (badge && badge.dataset.template) {
        const off = regular > total ? Math.round(((regular - total) * 100) / regular) : 0;
        badge.hidden = off <= 0;
        if (off > 0) badge.innerHTML = badge.dataset.template.replace('[percent]', off);
      }
      const perUnit = box.querySelector('.product-page__per-unit');
      if (perUnit && perUnit.dataset.template) {
        perUnit.hidden = quantity < 2;
        if (quantity >= 2) perUnit.textContent = perUnit.dataset.template.replace('[amount]', money(Math.round(total / quantity)));
      }
      const sticky = document.querySelector('.product-sticky-bar__price');
      if (sticky) sticky.textContent = money(total);
    }

    reprice(price) {
      const money = window.themeStrings.formatMoney;
      this.querySelectorAll('input[type="radio"]').forEach((radio) => {
        const quantity = Number(radio.dataset.quantity) || 1;
        const compare = price * quantity;
        const total = Math.round(compare * (1 - (Number(radio.dataset.discount) || 0) / 100));
        radio.dataset.totalPrice = money(total);
        const tier = radio.closest('.volume-tiers__tier');
        const current = tier.querySelector('.volume-tiers__tier-current');
        const compareEl = tier.querySelector('.volume-tiers__tier-compare');
        if (current) current.textContent = money(total);
        if (compareEl) compareEl.textContent = money(compare);
      });
      const checked = this.querySelector('input[type="radio"]:checked');
      this.showInPriceBox(checked);
      const totalLabel = document.querySelector('[data-product-total-label]');
      if (checked && totalLabel) {
        totalLabel.innerHTML = totalLabel.innerHTML.replace(/<strong>.*<\/strong>/, `<strong>${checked.dataset.totalPrice}</strong>`);
      }
    }

    onChange(event) {
      const radio = event.target.closest('input[type="radio"]');
      if (!radio) return;
      this.showInPriceBox(radio);

      // The product form's quantity field in this section, never the cart
      // drawer's (which comes first on the page once the cart has items).
      const scope = this.closest('.shopify-section') || document;
      const quantityInput =
        scope.querySelector('product-form [name="quantity"]') ||
        [...document.querySelectorAll('product-form [name="quantity"]')].find((el) => !el.closest('cart-drawer'));
      if (!quantityInput) return;

      quantityInput.value = radio.dataset.quantity;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

      const totalLabel = document.querySelector('[data-product-total-label]');
      if (totalLabel && radio.dataset.totalPrice) {
        totalLabel.innerHTML = totalLabel.innerHTML.replace(/<strong>.*<\/strong>/, `<strong>${radio.dataset.totalPrice}</strong>`);
      }
    }
  }

  if (!customElements.get('theme-volume-tiers')) {
    customElements.define('theme-volume-tiers', ThemeVolumeTiers);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    class QuantitySelector extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.quantity-selector__input');
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('mousedown', (event) => {
        if (event.target.closest('.quantity-selector__button')) event.preventDefault();
      });
    }

    onClick(event) {
      const button = event.target.closest('.quantity-selector__button');
      if (!button) return;

      const step = Number(button.dataset.step);
      const min = this.input.min === '' ? 1 : Number(this.input.min);
      const next = Math.max(min, Number(this.input.value) + step);
      if (next === Number(this.input.value)) return;

      this.input.value = next;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('quantity-selector')) {
    customElements.define('quantity-selector', QuantitySelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.product = JSON.parse(this.dataset.product);
      this.input = this.querySelector('[data-variant-id-input]');
      this.addEventListener('click', this.onValueClick.bind(this));
    }

    onValueClick(event) {
      const button = event.target.closest('.variant-picker__value');
      if (!button) return;

      const group = button.closest('.variant-picker__option');
      group.querySelectorAll('.variant-picker__value').forEach((el) => el.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');

      this.syncVariant();
    }

    syncVariant() {
      const selected = Array.from(this.querySelectorAll('.variant-picker__option')).map(
        (group) => group.querySelector('[aria-pressed="true"]')?.dataset.value
      );

      // match on the values shown on the page, then take the full variant by id
      const shown = JSON.parse(this.dataset.variantOptions || '[]');
      const hit = shown.find((variant) =>
        variant.o.slice(0, selected.length).every((value, index) => value === selected[index])
      );
      let match = hit
        ? this.product.variants.find((variant) => variant.id === hit.id)
        : this.product.variants.find((variant) =>
            [variant.option1, variant.option2, variant.option3]
              .slice(0, selected.length)
              .every((value, index) => value === selected[index])
          );

      if (match) {
        this.input.value = match.id;
        const chipLabel = this.querySelector('[data-chip-selected]');
        if (chipLabel) chipLabel.textContent = hit ? hit.o[0] : match.option1;
        // keep the address shareable: ?variant= points at the chosen option
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }

      this.dispatchEvent(new CustomEvent('variant:change', { detail: match, bubbles: true }));
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
